import React, { useState, useEffect } from "react";

import { showGrade } from "../../../../utils/textUtils";

import ClassMoreButton from "./ClassMoreButton";
import { LevelCreateModal } from "./LevelCreateModal";
import DeleteStudentLevelButton from "./DeleteStudentLevelButton";

const isMobileCheck = () =>
  Math.min(window.innerWidth, window.screen.width) <= 768;

const LevelList = ({ levels, allStudentList, setStudentList }) => {
  const [expandedLevels, setExpandedLevels] = useState({});
  const [isExpandedAll, setIsExpandedAll] = useState(false);
  const [isLevelModalOpen, setIsLevelModalOpen] = useState(false);
  const [editLevelId, setEditLevelId] = useState(null);
  const [selectedParams, setSelectedParams] = useState({
    levelId: null,
    studentId: null,
  });
  const [groupedStudents, setGroupedStudents] = useState({
    unassigned: { name: "클래스 없음", students: [] },
  });

  const handleToggle = (levelId) => {
    setExpandedLevels((prev) => ({ ...prev, [levelId]: !prev[levelId] }));
  };

  const expandAll = (bool) => {
    setExpandedLevels(
      levels.reduce((acc, level) => ({ ...acc, [level.id]: bool }), {
        unassigned: bool,
      })
    );
    setIsExpandedAll(bool);
  };

  const handleClickStudent = (student) => {
    if (selectedParams.studentId === student.id) {
      setSelectedParams({ levelId: null, studentId: null });
    } else {
      setSelectedParams({ levelId: null, studentId: student.id });
    }
  };

  const handleClickAllStudents = (levelId) => {
    if (selectedParams.levelId === levelId) {
      setSelectedParams({ levelId: null, studentId: null });
    } else {
      setSelectedParams({ levelId, studentId: null });
    }
  };

  useEffect(() => {
    if (selectedParams.levelId) {
      setStudentList(groupedStudents[selectedParams.levelId]?.students);
    } else if (selectedParams.studentId) {
      setStudentList(
        allStudentList.filter((s) => s.id === selectedParams.studentId)
      );
    } else {
      setStudentList(allStudentList);
    }
  }, [selectedParams]);

  useEffect(() => {
    const updated = levels.reduce(
      (acc, level) => {
        acc[level.id] = { name: level.name, students: [] };
        return acc;
      },
      { unassigned: { name: "클래스 없음", students: [] } }
    );
    allStudentList.forEach((student) => {
      if (student.level_list && student.level_list.length > 0) {
        student.level_list.forEach((level) => {
          updated[level.id]?.students.push(student);
        });
      } else {
        updated.unassigned.students.push(student);
      }
    });
    setGroupedStudents(updated);
  }, [levels, allStudentList]);

  const mobile = isMobileCheck();

  return (
    <div
      style={{
        width: mobile ? "100%" : "230px",
        border: "1px solid #E6EDEC",
        borderRadius: mobile ? "14px" : "18px 0 0 18px",
        borderRight: mobile ? "1px solid #E6EDEC" : "none",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
        flexShrink: 0,
        maxHeight: mobile ? "260px" : undefined,
        overflow: mobile ? "auto" : undefined,
        WebkitOverflowScrolling: "touch",
      }}
    >
      {/* 헤더 */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 14px",
          borderBottom: "1.5px solid #0E141B",
          fontSize: "0.9rem",
          fontWeight: 800,
          color: "#0E141B",
          gap: "10px",
          position: "sticky",
          top: 0,
          backgroundColor: "#fff",
          zIndex: 1,
          letterSpacing: "-0.01em",
        }}
      >
        <span>
          전체{" "}
          <span style={{ color: "#00A396" }}>{allStudentList.length}명</span>
        </span>
        <button
          onClick={() => expandAll(!isExpandedAll)}
          style={{
            padding: "4px 12px",
            backgroundColor: "#F4F8F7",
            color: "#7A8490",
            border: "none",
            borderRadius: "999px",
            cursor: "pointer",
            fontSize: "0.76rem",
            fontWeight: 700,
            fontFamily: "inherit",
          }}
        >
          {isExpandedAll ? "모두 닫기" : "모두 열기"}
        </button>
      </div>

      <ul style={{ listStyle: "none", padding: 0, margin: 0, overflow: "auto", flex: 1 }}>
        {Object.entries(groupedStudents).map(
          ([levelId, { name, students }]) => (
            <li key={levelId}>
              <div
                style={{
                  backgroundColor: expandedLevels[levelId]
                    ? "#F4F8F7"
                    : "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 14px",
                  borderBottom: "1px solid #E6EDEC",
                  fontSize: "0.88rem",
                  fontWeight: 700,
                  color: expandedLevels[levelId] ? "#0E141B" : "#7A8490",
                  gap: "8px",
                  cursor: "pointer",
                  transition: "background-color .12s",
                }}
                onClick={() => handleToggle(levelId)}
              >
                <span>{name}</span>
                <span
                  style={{
                    fontSize: "0.78rem",
                    fontWeight: 700,
                    color: "#7A8490",
                  }}
                >
                  {students.length}명
                </span>
                <div
                  style={{ marginLeft: "auto" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <ClassMoreButton
                    levelId={levelId}
                    levelName={name}
                    editLevelId={editLevelId}
                    setEditLevelId={setEditLevelId}
                    groupedStudents={groupedStudents}
                  />
                </div>
              </div>
              {/* 펼침: 전체 학생 */}
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  overflow: "hidden",
                  maxHeight: expandedLevels[levelId] ? "none" : "0",
                  opacity: expandedLevels[levelId] ? 1 : 0,
                  transition: "max-height 0.3s ease, opacity 0.3s ease",
                  fontSize: "0.84rem",
                }}
              >
                <li
                  style={{
                    padding: "7px 14px",
                    color:
                      selectedParams.levelId === levelId
                        ? "#0E141B"
                        : "#7A8490",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                  onClick={() => handleClickAllStudents(levelId)}
                >
                  전체 학생
                </li>
              </ul>
              {/* 펼침: 개별 학생 */}
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  overflow: "hidden",
                  maxHeight: expandedLevels[levelId] ? "none" : "0",
                  opacity: expandedLevels[levelId] ? 1 : 0,
                  transition: "max-height 0.3s ease, opacity 0.3s ease",
                  fontSize: "0.84rem",
                }}
              >
                {students.map((student) => (
                  <li
                    key={student.id}
                    style={{
                      display: "flex",
                      padding: "6px 14px",
                      color:
                        selectedParams.studentId === student.id
                          ? "#0E141B"
                          : "#7A8490",
                      cursor: "pointer",
                    }}
                    onClick={() => handleClickStudent(student)}
                  >
                    {student.name} ({showGrade(student.grade)})
                    {levelId !== "unassigned" && (
                      <div style={{ marginLeft: "auto" }}>
                        <DeleteStudentLevelButton
                          student={student}
                          levelId={levelId}
                          name={name}
                        />
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </li>
          )
        )}
      </ul>

      {/* 반 추가 */}
      <div style={{ padding: "10px 12px" }}>
        <button
          style={{
            width: "100%",
            padding: "9px 18px",
            backgroundColor: "transparent",
            border: "1.5px dashed #B9C1C9",
            borderRadius: "10px",
            cursor: "pointer",
            fontSize: "0.84rem",
            fontWeight: 700,
            color: "#7A8490",
            fontFamily: "inherit",
            transition: "border-color .12s, color .12s",
          }}
          onClick={() => setIsLevelModalOpen(true)}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = "#00D9C0";
            e.currentTarget.style.color = "#00A396";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "#B9C1C9";
            e.currentTarget.style.color = "#7A8490";
          }}
        >
          + 반 추가
        </button>
      </div>

      {isLevelModalOpen && (
        <LevelCreateModal setIsLevelModalOpen={setIsLevelModalOpen} />
      )}
    </div>
  );
};

export default LevelList;
